import {combineReducers} from 'redux-immutable';

import treeReducer from '../tree/reducer';
import EssayReport from './component';
import mainReducer from './reducer';


export const initialState = {};

export const reducer = combineReducers({
    main: mainReducer,
    regionsTree: treeReducer,
    citiesTree: treeReducer,
    schoolsTree: treeReducer,
});

export const component = EssayReport;
